"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typography = void 0;
exports.typography = {
    fontFamily: 'Poppins',
    fontSize: 14,
    h1: {
        fontSize: 64,
        fontWeight: 600,
        lineHeight: 1.5,
        fontFamily: 'Poppins',
    },
    h2: {
        fontSize: 48,
        fontWeight: 600,
        lineHeight: 1.2,
        fontFamily: 'Poppins',
    },
    h3: {
        fontSize: 36,
        fontWeight: 600,
        lineHeight: 1,
        fontFamily: 'Poppins',
    },
    h4: {
        fontSize: 24,
        fontWeight: 600,
        fontFamily: 'Poppins',
    },
    h5: {
        fontSize: 20,
        fontWeight: 600,
        fontFamily: 'Poppins',
    },
    h6: {
        fontSize: 16,
        fontWeight: 600,
        fontFamily: 'Poppins',
    },
    subtitle1: {
        fontSize: 16,
        fontFamily: 'Poppins',
    },
    subtitle2: {
        fontSize: 14,
        fontWeight: 500,
        fontFamily: 'Poppins',
    },
    body1: {
        fontSize: 16,
        fontFamily: 'Poppins',
    },
    body2: {
        fontSize: 14,
        fontFamily: 'Poppins',
    },
    caption: {
        fontSize: 12,
        fontFamily: 'Poppins',
    },
    overline: {
        fontSize: 12,
        fontWeight: 500,
        fontFamily: 'Poppins',
    },
};
//# sourceMappingURL=typography.js.map